import { FETCH_ASSIGNED_CREATIVES } from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";
import { normalizeDataByField } from "../utils/normalize";

const initialState = { isLoading: true, byId: {}, allIds: [] };

export const dcmAssignedCreatives = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSIGNED_CREATIVES:
      switch (action.status) {
        case SUCCESS:
          let { byId, allIds } = normalizeDataByField(action.data, "id");

          return { isLoading: false, byId, allIds };
        case FAILURE:
          return {
            isLoading: false,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        case PENDING:
          return {
            isLoading: true,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        default:
          return state;
      }
    default:
      return state;
  }
};
